import { getAPI } from "./base";

export async function fetchCostDrivers(formValues) {
  try {
    const api = getAPI();
    const params = {
      Country: formValues.country,
      Sector: formValues.sector,
      Category: formValues.category || null,
      L2: formValues.L2 || null,
      L3: formValues.L3 || null,
      L4: formValues.L4 || null,
    };

    const response = await api.get("/costdrivers", { params });
    if (response.status === 200) {
      return response.data.slice(0, 20);
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}
